// 全域連線狀態 banner（W2-02；spec 10 §4.3 degraded/offline 呈現、§7 表、
// AC-OS-8：「down=灰階+outbox 計數；WSS 斷=黃 banner；OK=無 banner」）。
// 文案逐字取 spec 字串（lib/connection.ts），供 e2e 直接斷言。

import { DEGRADED_BANNER_TEXT, OFFLINE_BANNER_TEXT, useConnectionMode } from '../lib/connection';

export function ConnectionBanner() {
  const mode = useConnectionMode();
  if (mode === 'online') return null;
  return mode === 'degraded' ? (
    <div className="conn-banner conn-banner-degraded" role="status">
      {DEGRADED_BANNER_TEXT}
    </div>
  ) : (
    <div className="conn-banner conn-banner-offline" role="status">
      {OFFLINE_BANNER_TEXT}
    </div>
  );
}
